<!-- Author item new design -->

<div
  class="group w-full border-b border-neutral-300 py-4 text-neutral-800 transition-colors"
>
  <!-- Mobile Layout -->
  <div class="flex flex-col gap-1 lg:hidden">
    <ng-container
      [ngTemplateOutlet]="authorContent"
      [ngTemplateOutletContext]="{
        containerClass: 'flex items-start justify-between',
      }"
    ></ng-container>
  </div>

  <!-- Desktop Layout -->
  <div class="hidden lg:grid lg:grid-cols-4 lg:items-center">
    <ng-container
      [ngTemplateOutlet]="authorContent"
      [ngTemplateOutletContext]="{ containerClass: 'contents' }"
    ></ng-container>
  </div>
</div>

<ng-template #authorContent let-containerClass="containerClass">
  <div [class]="containerClass">
    <div
      class="text-lg font-medium transition-all duration-300 group-hover:text-gray-400 lg:col-span-2"
    >
      {{ author() | formatAuthorName }}
    </div>
    <!-- Arrow (visible only on mobile) -->
    <div
      class="h-3 w-3 transition-all duration-300 group-hover:translate-x-1 lg:hidden"
    >
      <img
        [attr.alt]="'pages.authors.viewDetails' | translate"
        src="assets/icons/diagonal_arrow_icon.svg"
      />
    </div>
  </div>
  <div
    class="text-base transition-all duration-300 group-hover:text-gray-400 lg:text-lg"
  >
    {{ author().company_name }}
  </div>
  <!-- Arrow (visible only on desktop) -->
  <div class="hidden lg:flex lg:justify-end">
    <div class="h-3 w-3 transition-all duration-300 group-hover:translate-x-1">
      <img
        [attr.alt]="'pages.authors.viewDetails' | translate"
        src="assets/icons/diagonal_arrow_icon.svg"
      />
    </div>
  </div>
</ng-template>
